<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2" id="contents"><a id="page_v"></a><strong>CONTENTS</strong></h2>
<p class="toc"><a class="nounder" href="#/xhtml/preface">PREFACE</a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch01">CHAPTER 1<br/><strong>Race and the Character of the FBI</strong></a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch02">CHAPTER 2<br/><strong>Secret Reconstruction, 1871–1905</strong></a></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch03" title="Link target outside of Sample">CHAPTER 3<br/><strong>Proud Genesis, 1905–1909</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch04" title="Link target outside of Sample">CHAPTER 4<br/><strong>Loss of Mission, 1909–1924</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch05" title="Link target outside of Sample">CHAPTER 5<br/><strong>The First Age of Reform, 1924–1939</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch06" title="Link target outside of Sample">CHAPTER 6<br/><strong>Counterespionage and Control, 1938–1945</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch07" title="Link target outside of Sample">CHAPTER 7<br/><strong>The Alienation of Liberal America, 1924–1943</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch08" title="Link target outside of Sample">CHAPTER 8<br/><strong>Gestapo Fears and the Intelligence Schism, 1940–1975</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch09" title="Link target outside of Sample">CHAPTER 9<br/><strong>Anachronism as Myth and Reality, 1945–1972</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch10" title="Link target outside of Sample">CHAPTER 10<br/><strong>A Crisis of American Democracy, 1972–1975</strong></span></p>
<p class="toc"><a id="page_vi"></a><span class="nounder" href="#/xhtml/ch11" title="Link target outside of Sample">CHAPTER 11<br/><strong>Reform and Its Critics, 1975–1980</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch12" title="Link target outside of Sample">CHAPTER 12<br/><strong>Mission Regained, 1981–1993</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch13" title="Link target outside of Sample">CHAPTER 13<br/><strong>Strife and Slippage, 1993–2001</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch14" title="Link target outside of Sample">CHAPTER 14<br/><strong>9/11 and the Quest for National Unity</strong></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/notes" title="Link target outside of Sample">NOTES</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/bib" title="Link target outside of Sample">BIBLIOGRAPHY</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/index" title="Link target outside of Sample">INDEX</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?51a03c5f